<template>
  <div class="md-layout text-main-black contact-layout">
    <div class="md-layout-item md-size-100 mobile-layout">
      <md-card class="mobile-card contacts-card text-main-black">
        <md-card-content class="mobile-content">
          <div class="contacts-card-wrapper">
            <div class="contacts-card-title text-main-black">{{ name }}</div>
            <div class="work-hours">
              {{ workTime }}
            </div>
            <md-divider style="margin: 5px 0"></md-divider>
            <div class="address-row">
              {{ address }}
<!--              <router-link :to="{ name: 'ContactsMap'}" class="md-theme-link">-->
<!--                {{ address }}-->
<!--              </router-link>-->
<!--              <router-link :to="{ name: 'ContactsMap'}" class="md-theme-link">-->
<!--                <md-icon class="md-primary">chevron_right</md-icon>-->
<!--              </router-link>-->
            </div>
            <md-divider style="margin: 5px 0"></md-divider>
            <table class="custom-dense-table">
              <tbody>
              <tr v-for="(phone, iP) in phones" :key="iP + 'phone'" >
                <td>{{ phone.name }} {{ phone.comment }}</td>
                <td class="text-align-right">
                  <div v-for="p in phone.value.split(',')">
                    <a class="link-lower-case md-theme-link" :href="`tel:${p}`">
                      {{ p }}
                    </a>
                  </div>
                </td>
              </tr>

              <tr v-for="(email, iE) in emails" :key="iE + 'email'" >
                <td>
                  {{
                    email.comment
                      ? `${email.name} (${email.comment})`
                      : email.name
                  }}: {{ email.comment ? `(${email.comment}):` : "" }}
                </td>
                <td class="text-align-right api-link-td">
                  <div
                    class="api-link"
                    v-html="prepareLink(email.value)"
                  />
                </td>
              </tr>

              <tr v-for="(site, iS) in websites" :key="iS + 'site'" >
                <td>{{ site.name }}</td>
                <td class="text-align-right api-link-td">

                  <div
                    class="api-link"
                    v-html="prepareLink(site.value)"
                  />
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Autolinker from "autolinker";

export default {
  name: "ContactsPage",
  computed: {
    ...mapGetters(["getPersonalAccountInfo", "getManageOrganizationInfo"]),

    name() {
      return this.getManageOrganizationInfo.name;
    },
    workTime() {
      return this.getManageOrganizationInfo.workTime;
    },
    phones() {
      return this.getManageOrganizationInfo.phones;
    },
    emails() {
      return this.getManageOrganizationInfo.emails;
    },
    address() {
      return this.getManageOrganizationInfo.address;
    },
    websites() {
      return this.getManageOrganizationInfo.websites;
    }
  },
  methods: {
    prepareLink(link) {
      const autolinker = new Autolinker({ className: "link-lower-case md-theme-link" });
      return autolinker.link(link);
    }
  }
};
</script>

<style scoped lang="scss">
.contacts-card {
  max-width: 785px;
  @media (max-width: 768px) {
    margin-bottom: 0;
  }
  .md-card-content {
    padding: 25px 20px;
    @media (max-width: 768px) {
      padding: 0 !important;
      height: calc(100vh - 65px);
    }
  }
  .custom-dense-table tbody td {
    white-space: normal;
  }
  .address-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
  }
  &-title {
    font-size: 17px;
    font-weight: 600;
    margin-bottom: 5px;
    padding-left: 10px;
    @media (max-width: 768px) {
      padding: 15px 10px;
      background-color: #eee;
      border-bottom: 1px solid #aaa;
    }
  }
  &-wrapper {
    padding: 0 10px;
    @media (max-width: 768px) {
      padding: 0;
    }
  }
  .work-hours {
    white-space: pre-line;
    padding: 0 10px;
  }
  .api-link-td {
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .api-link {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
